module.exports = __webpack_public_path__ + "static/media/COS_PERRIGO.398e806a.png";